import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceConsumptionSummary } from '@eadsysteme/energyefficiencyclient-v2';
import { NumberUtil } from '../../../../util/NumberUtil';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { FormulaUtilService } from '../../../../services/FormulaUtil.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-calculation-info-dialog',
	templateUrl: './calculation-info-dialog.component.html',
	styleUrls: ['./calculation-info-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatButton, MatIcon],
})
export class CalculationInfoDialogComponent {
	dialogRef = inject<MatDialogRef<CalculationInfoDialogComponent>>(MatDialogRef);
	numberUtil = inject(NumberUtil);
	private translocoLocale = inject(TranslocoLocaleService);
	formulaUtil = inject(FormulaUtilService);

	summedEnergy: DeviceConsumptionSummary[];
	protected readonly locale: string;

	constructor() {
		const summedEnergy = inject(MAT_DIALOG_DATA);

		this.summedEnergy = summedEnergy;
		this.locale = this.translocoLocale.getLocale();
		this.numberUtil._locale = this.locale;
	}

	close() {
		this.dialogRef.close();
	}
}
